import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import ImageUploadSection from "../../components/ImageUploadSection/ImageUploadSection";
import Button from "../../components/Button/Button";
import {
  filterFormErrorObject,
  isAnyKeyValueTrue,
  mapObjectValues,
  objectHasKeys,
  validateDrivingLicenseNumber,
  validateEmail,
  validatePhoneNumber,
  validatePostalCode,
  validatePresence,
} from "../../helpers/validationHelpers";
import { Dispatch, SetStateAction, useState } from "react";
import moment from "moment";
import useFormFieldsBlurState from "../../hooks/useFormFieldsBlurState";
import { uploadAssetToCloudinary } from "../../utils/cloudinary";
import PublicOrganizationAutoComplete from "../../components/OrganizationAutoComplete/PublicOrganizationAutoComplete";
import ErrorHelperText from "../../components/ErrorHelperText/ErrorHelperText";
import PhoneNumberTextField from "../../components/PhoneNumberTextField/PhoneNumberTextField";
import { DatePicker } from "@mui/x-date-pickers";
import cities from "../../utils/cities.json";
import provinces from "../../utils/provinces.json";
import { DriverUsingOwnVehicleOptions } from "./constants";
const DriverLicenseAndInsuranceNumberForm = ({
  drivingLicenseNumber,
  setDrivingLicenseNumber,
  insurancePolicyNumber,
  setInsurancePolicyNumber,
  driverUsingOwnVehicle,
  setDriverUsingOwnVehicle,
  driverUsingOrganizationVehicle,
  setDriverUsingOrganizationVehicle,
}: {
  drivingLicenseNumber: string;
  setDrivingLicenseNumber: Dispatch<SetStateAction<string>>;
  insurancePolicyNumber: string;
  setInsurancePolicyNumber: Dispatch<SetStateAction<string>>;
  driverUsingOwnVehicle: boolean;
  setDriverUsingOwnVehicle: Dispatch<SetStateAction<boolean>>;
  driverUsingOrganizationVehicle: boolean;
  setDriverUsingOrganizationVehicle: Dispatch<SetStateAction<boolean>>;
}) => {
  const {
    blurredFormFields,
    setFormFieldToBlurred,
    setFormFieldToFocused,
    resetBlurState,
  } = useFormFieldsBlurState({
    drivingLicenseNumber,
  });

  const formErrors = {
    drivingLicenseNumber: {
      empty:
        blurredFormFields.drivingLicenseNumber &&
        !validatePresence(drivingLicenseNumber) &&
        "Please enter a driving license number",
      error:
        blurredFormFields.drivingLicenseNumber &&
        !validatePresence(drivingLicenseNumber) &&
        !validateDrivingLicenseNumber(drivingLicenseNumber) &&
        "Kindly enter the driver license number without any spaces or special characters",
    },
    insurancePolicyNumber: {
      empty:
        driverUsingOwnVehicle &&
        !validatePresence(insurancePolicyNumber) &&
        "Please enter an insurance policy number",
    },
  };

  const parsedFormErrors = filterFormErrorObject(formErrors);

  return (
    <>
      <Grid container item spacing={2}>
        <Grid item xs={12}>
          <TextField
            label={"Drivers License Number"}
            fullWidth
            value={drivingLicenseNumber}
            error={Boolean(isAnyKeyValueTrue(formErrors.drivingLicenseNumber))}
            onChange={(e) => {
              setDrivingLicenseNumber(e.target.value);
            }}
            onFocus={() => {
              setFormFieldToFocused("drivingLicenseNumber");
            }}
            onBlur={() => {
              setFormFieldToBlurred("drivingLicenseNumber");
            }}
          />
          {mapObjectValues(
            parsedFormErrors?.drivingLicenseNumber,
            (key: any, index: any) => (
              <ErrorHelperText
                key={`create-new-driver-driver-profile-driving-license-number-errors-${index}`}
                errorText={parsedFormErrors?.drivingLicenseNumber[key]}
              />
            )
          )}
        </Grid>
      </Grid>
      <Grid container item spacing={2}>
        <Grid item xs={12}>
          <TextField
            label={"Insurance Policy Number"}
            fullWidth
            value={insurancePolicyNumber}
            error={Boolean(isAnyKeyValueTrue(formErrors.insurancePolicyNumber))}
            onChange={(e) => {
              setInsurancePolicyNumber(e.target.value);
            }}
            onFocus={() => {
              setFormFieldToFocused("insurancePolicyNumber");
            }}
            onBlur={() => {
              setFormFieldToBlurred("insurancePolicyNumber");
            }}
          />
          {mapObjectValues(
            parsedFormErrors?.insurancePolicyNumber,
            (key: any, index: any) => (
              <ErrorHelperText
                key={`create-new-driver-driver-profile-insurance-policy-number-errors-${index}`}
                errorText={parsedFormErrors?.insurancePolicyNumber[key]}
              />
            )
          )}
        </Grid>
      </Grid>
      <Grid container item spacing={2}>
        <Grid container item xs={12}>
          <Grid item>
            <Typography>
              Whose vehicle will you be driving to deliver the service?
            </Typography>
          </Grid>
        </Grid>
        {/* <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel>
              Whose vehicle will you be driving to deliver the service?
            </InputLabel>
            <Select
              onChange={(e) => {
                setDriverUsingOwnVehicle(
                  e.target.value as DriverUsingOwnVehicleOptions
                );
              }}
              value={driverUsingOwnVehicle}
              label="Whose vehicle will you be driving to deliver the service?"
            >
              <MenuItem value={DriverUsingOwnVehicleOptions.selfOwnedVehicle}>
                {DriverUsingOwnVehicleOptions.selfOwnedVehicle}
              </MenuItem>
              <MenuItem
                value={DriverUsingOwnVehicleOptions.organizationOwnedVehicle}
              >
                {DriverUsingOwnVehicleOptions.organizationOwnedVehicle}
              </MenuItem>
            </Select>
          </FormControl>
        </Grid> */}
        <Grid container item>
          <Grid item>
            <FormControlLabel
              control={
                <Checkbox
                  checked={driverUsingOwnVehicle}
                  value={driverUsingOwnVehicle}
                  onChange={(e) => {
                    setDriverUsingOwnVehicle(e.target.checked);
                  }}
                />
              }
              sx={{ color: "#868686" }}
              label={"I will be driving my own vehicle"}
            />
          </Grid>
        </Grid>
        <Grid container item>
          <Grid item>
            <FormControlLabel
              control={
                <Checkbox
                  checked={driverUsingOrganizationVehicle}
                  value={driverUsingOrganizationVehicle}
                  onChange={(e) => {
                    setDriverUsingOrganizationVehicle(e.target.checked);
                  }}
                />
              }
              sx={{ color: "#868686" }}
              label={"I will be driving an Organization supplied vehicle."}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default DriverLicenseAndInsuranceNumberForm;
